import React from 'react';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
    pinTab,
    unpinTab,
} from '~Betslip/slices/uiSlice';

import {
    selectDisplaySinglesContent,
    selectDisplayParlayContent,
    selectDisplayMultiplesContent,
    selectPinnedTab,
} from '~Betslip/selectors/uiSelectors';

import {
    selectIsParlayTabAvailable,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectIsMultiplesTabAvailable,
} from '~Betslip/selectors/userMultiplesSelectors';

import {
    selectCountSelectionDetails,
} from '~Betslip/selectors/selectionDetailsSelectors';

import './styles.scss';

const ContentTabs = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();

    const isSinglesTab = useSelector(selectDisplaySinglesContent);
    const isParlayTab = useSelector(selectDisplayParlayContent);
    const isMultiplesTab = useSelector(selectDisplayMultiplesContent);

    const pinnedTab = useSelector(selectPinnedTab);

    const isParlayTabAvailable = useSelector(selectIsParlayTabAvailable);
    const isMultiplesTabAvailable = useSelector(selectIsMultiplesTabAvailable);

    const selectionsCount = useSelector(selectCountSelectionDetails);

    const changeTab = (tab) => dispatch(tab ? pinTab(tab) : unpinTab());

    if (!isMultiplesTabAvailable && pinnedTab === 'multiples' && selectionsCount > 0) {
        changeTab(null);
    }

    const renderSinglesTab = () => {
        const classes = classNames(
            'fullslip__contentTab',
            isSinglesTab && 'fullslip__contentTab--active',
        );

        return (
            <li
                className={classes}
                data-spectate-product="new-betslip;bet-type-tab;singles"
                onClick={() => changeTab('singles')}
            >
                {t('betslip.singles')}
            </li>
        );
    };

    const renderParlayTab = () => {
        const classes = classNames(
            'fullslip__contentTab',
            isParlayTab && 'fullslip__contentTab--active',
            !isParlayTabAvailable && 'fullslip__contentTab--unavailable',
        );

        return (
            <li
                className={classes}
                data-spectate-product="new-betslip;bet-type-tab;parlay"
                onClick={() => isParlayTabAvailable && changeTab(null)}
            >
                {t('betslip.parlay')}
            </li>
        );
    };

    const renderMultiplesTab = () => {
        const classes = classNames(
            'fullslip__contentTab',
            isMultiplesTab && 'fullslip__contentTab--active',
            !isMultiplesTabAvailable && 'fullslip__contentTab--unavailable',
        );

        return (
            <li
                className={classes}
                data-spectate-product="new-betslip;bet-type-tab;round-robin"
                onClick={() => isMultiplesTabAvailable && changeTab('multiples')}
            >
                {t('betslip.multiples')}
            </li>
        );
    };

    return (
        <ul className="fullslip__contentTabs">
            {renderSinglesTab()}
            {renderParlayTab()}
            {renderMultiplesTab()}
        </ul>
    );
};

export default ContentTabs;
